<template>
  <WeatherUpdateDetails :if="eventId" :eventId="eventId"/>
</template>

<script>
import WeatherUpdateDetails from '@/components/WeatherUpdateDetails.vue'

export default {
  name: 'WeatherUpdateDetailsManagement',
  components: {
   WeatherUpdateDetails
  },
  data: () => {
    return {
      eventId: undefined
    }
  },
  mounted() {
    const routeId = this.$route.params.id
    this.eventId = routeId
  }
}
</script>
